import { render } from "./ProductInfoCell.vue?vue&type=template&id=23bce5a5&scoped=true"
import script from "./ProductInfoCell.vue?vue&type=script&lang=js"
export * from "./ProductInfoCell.vue?vue&type=script&lang=js"

import "./ProductInfoCell.vue?vue&type=style&index=0&id=23bce5a5&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23bce5a5"]])

export default __exports__